<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[700px]" style="height: 590px; overflow-y: auto;">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>{{text}} Category</h5>
    <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="submitCategory()">
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Category</label>
        <input type="text" class="form-control" [(ngModel)]="selectedCategory.categoryID"
          [ngModelOptions]="{ standalone: true }" [disabled]="text !== 'Add'">
      </div>

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Category Text</label>
        <input type="text" class="form-control" [(ngModel)]="selectedCategory.categoryText"
          [ngModelOptions]="{ standalone: true }">
      </div>

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Help Text</label>
        <quill-editor #editor [(ngModel)]="selectedCategory.helpText" name="helpText">
        </quill-editor>
      </div>

      <button class="btn btn-primary btn-lg col-md-10" type="submit">Save</button>
    </form>
  </div>
</div>